import React from "react";
import { getSlot } from "@/mds/utils/slots";
import { MDSPlanCardProps, MDSPlanCardSlot } from "./plan-card.types";
import { MDSPlanCardPrice } from "./price";
import { MDSPlanCardFeatures } from "./features";
import {
  StyledPlanCard,
  StyledPlanCardContainer,
  StyledPlanCardFooter,
  StyledPlanCardTitle,
} from "./plan-card.styles";
import {
  StyledSectionSeparator,
  StyledSectionSeparatorLine,
} from "@/mds/components/section/section.style";

export const MDSPlanCard: React.FC<MDSPlanCardProps> = ({
  plan,
  features,
  children,
  background,
  border,
  maxWidth,
  priceVariant,
  priceTermVariant,
}: MDSPlanCardProps) => {
  const title = getSlot(children, MDSPlanCardSlot.Title);
  const price = getSlot(children, MDSPlanCardSlot.Price);
  const priceTerm = getSlot(children, MDSPlanCardSlot.PriceTerm);
  const priceBadge = getSlot(children, MDSPlanCardSlot.TitleBadge);
  const footer = getSlot(children, MDSPlanCardSlot.Footer);

  return (
    <StyledPlanCardContainer $maxWidth={maxWidth}>
      <StyledPlanCard
        $plan={plan}
        $background={background}
        $border={border}
        data-mds-name="PlanCard"
      >
        <StyledPlanCardTitle>
          {title}
          {priceBadge}
        </StyledPlanCardTitle>

        <StyledSectionSeparator>
          <StyledSectionSeparatorLine />
        </StyledSectionSeparator>

        <MDSPlanCardPrice priceVariant={priceVariant} priceTermVariant={priceTermVariant}>
          {price}
          {priceTerm}
        </MDSPlanCardPrice>

        <MDSPlanCardFeatures plan={plan} labels={features} />

        {footer && <StyledPlanCardFooter>{footer}</StyledPlanCardFooter>}
      </StyledPlanCard>
    </StyledPlanCardContainer>
  );
};
